import { useEffect } from "react";

export const useDisableNumberInputScroll = () => {
  useEffect(() => {
    const handleWheel = (e: WheelEvent) => {
      const target = e.target as HTMLElement;

      // Check if the event target is an input of type 'number'
      if (target.tagName === "INPUT" && (target as HTMLInputElement).type === "number") {
        // Blur the input to remove focus, or simply prevent default
        e.preventDefault();
      }
    };

    // Attach the listener to the entire document
    document.addEventListener("wheel", handleWheel, { passive: false });

    // Clean up
    return () => {
      document.removeEventListener("wheel", handleWheel);
    };
  }, []); // The empty array is perfect now, because the document always exists
};

export default useDisableNumberInputScroll;
